import React from "react";

export default function GrowthLoopFnB() {
  return (
    <div className="space-y-6 text-sm text-gray-100 leading-relaxed">
      {/* Header */}
      <h1 className="text-xl font-bold text-yellow-200">
        GrowthLoop – Features & Benefits ✨
      </h1>

      {/* Intro */}
      <p className="text-xs lg:text-sm text-white">
        🧠 GrowthLoop is a{" "}
        <strong>non-clinical cognitive infrastructure</strong> designed to help
        children build attention, emotional regulation, executive function, and
        learning readiness through visible systems — not labels or punishment.
      </p>

      {/* Feature Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {/* Card 1 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            👨‍👩‍👧‍🏫 Multi-Stakeholder Observational Framework
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            👀 Parents, educators, and doctors independently observe the same
            developmental domains, creating 360° visibility of the child’s lived
            experience.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            ✅ Benefit: Eliminates single-observer bias and builds shared language.
          </p>
        </section>

        {/* Card 2 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            🧩 Domain-Based Developmental Mapping
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            🧠 Tracks six foundational domains — attention, executive function,
            emotional regulation, self-esteem, learning readiness, and impulse
            regulation.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            🎯 Benefit: Focuses on root capabilities, not surface academic
            symptoms.
          </p>
        </section>

        {/* Card 3 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            📊 Consistency Index
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            🔄 Automatically reveals alignment or divergence across home, school,
            and clinical environments.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            🔍 Benefit: Separates environmental friction from systemic needs.
          </p>
        </section>

        {/* Card 4 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            🧠 DeepThinking (Root-Cause Reflection)
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            ❓ Guided “why-based” reflection explores triggers, structure
            dependency, context sensitivity, and co-regulation needs.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            🛠️ Benefit: Converts behaviour into actionable system insight.
          </p>
        </section>

        {/* Card 5 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            📓 Chronicle – Effort & Continuity Log
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            🕒 Tracks attempts, routines, and follow-through over time — not grades
            or outcomes.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            🌱 Benefit: Makes growth visible and resilience measurable.
          </p>
        </section>

        {/* Card 6 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            👏 Applause System
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            💛 Reinforces effort, consistency, and completion instead of
            comparison or ranking.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            🔥 Benefit: Builds intrinsic motivation and self-belief.
          </p>
        </section>

        {/* Card 7 */}
        <section className="h-full border border-gray-400 rounded-xl p-4 flex flex-col hover:border-cyan-400 transition-colors">
          <h2 className="font-semibold text-cyan-300">
            🛡️ Ethical Dashboards
          </h2>
          <p className="text-xs text-white pl-6 mt-2">
            📈 Open and observer dashboards provide aggregate, non-identifiable
            insights for institutions and policymakers.
          </p>
          <p className="text-xs text-cyan-200 pl-6 mt-auto pt-2">
            🔐 Benefit: Enables scale without compromising child privacy.
          </p>
        </section>
      </div>

      {/* Footer Philosophy */}
      <p className="text-xs text-cyan-200 italic">
        GrowthLoop replaces “What’s wrong?” with “What’s missing in the system?”
      </p>
    </div>
  );
}
